var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"photos-gallery"},_vm._l((_vm.files),function(file,i){return _c('li',{key:i},[_c('div',{staticClass:"photos-thumbnail"},[_c('file-thumbnail',{attrs:{"fileId":file._fileId,"width":"40"}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }